import { useState } from 'react';
import CreatePaymentReceivedHeader from './createPaymentReceivedHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import PaymentReceivedForm from './paymentReceivedForm';
import { useParams } from 'react-router-dom';

const CreatePaymentReceived = () => {
	const [error, setError] = useState({});
	const [tableError, setTableError] = useState([]);
	const param = useParams();
	const id = param?.id;
	const [paymentReceived, setPaymentRecieved] = useState({
		customer_id: null,
		payment_receive_number: null,
		date: getCurrentDate(),
		received_payment_amount: null,
		deposit_to_id: 1,
		notes: '',
		payment_method: null,
	});
	const [paymentReceivedTable, setPaymentReceivedTable] = useState([]);
	const handlePaymentChange = (index, value) => {
		const paymentBillsData = [...paymentReceivedTable];
		paymentBillsData[index].payment_amount = value;
		setPaymentReceivedTable(paymentBillsData);
		const isValid = Number(paymentBillsData[index].due_amount) >= Number(value);
		setTableError((prev) => {
			const filtered = prev.filter((error) => error.index !== index);

			return isValid ? filtered : [...filtered, { index, error: 'Invalid Payment' }];
		});
	};
	const handleFullPaymentToggle = (index, type) => {
		if (type === 'pay') {
			if (Number(paymentReceived?.received_payment_amount || 0) > 0) {
				const paymentAmount = paymentReceivedTable?.reduce(
					(total, bill) => Number(total) + Number(bill.payment_amount),
					0,
				);
				if (
					Number(paymentReceived?.received_payment_amount) - Number(paymentAmount) >
					Number(paymentReceivedTable[index].due_amount)
				) {
					const paymentBillsData = [...paymentReceivedTable];
					paymentBillsData[index].payment_amount = paymentBillsData[index].due_amount;
					setPaymentReceivedTable(paymentBillsData);
				} else {
					const paymentBillsData = [...paymentReceivedTable];
					paymentBillsData[index].payment_amount =
						Number(paymentReceived?.received_payment_amount) - Number(paymentAmount);
					setPaymentReceivedTable(paymentBillsData);
				}
			} else {
				var newError = { ...error };
				newError.received_payment_amount = 'Please enter payment received amount in the field';
				setError(newError);
			}
		} else {
			const paymentBillsData = [...paymentReceivedTable];
			paymentBillsData[index].payment_amount = 0.0;
			setPaymentReceivedTable(paymentBillsData);
		}
	};

	const calculateTotalPayment = () => {
		return paymentReceivedTable?.reduce(
			(total, bill) => Number(total) + Number(bill.payment_amount),
			0,
		);
	};

	const calculateTotalExcessPayment = () => {
		const paymentAmount = paymentReceivedTable?.reduce(
			(total, bill) => Number(total) + Number(bill.payment_amount),
			0,
		);

		return Number(paymentReceived?.received_payment_amount ?? 0) - Number(paymentAmount);
	};

	function handleClearAppliedAmount() {
		const paymentBillsData = paymentReceivedTable.map((item) => ({
			...item,
			payment_amount: '',
		}));
		setPaymentReceivedTable(paymentBillsData);
	}
	return (
		<div>
			<CreatePaymentReceivedHeader
				error={error}
				setError={setError}
				tableError={tableError}
				setTableError={setTableError}
				paymentReceived={paymentReceived}
				paymentReceivedTable={paymentReceivedTable}
				totalAmount={calculateTotalPayment}
				calculateTotalExcessPayment={calculateTotalExcessPayment}
			/>
			<PaymentReceivedForm
				paymentReceived={paymentReceived}
				error={error}
				setError={setError}
				setPaymentReceived={setPaymentRecieved}
				setPaymentReceivedTable={setPaymentReceivedTable}
				paymentsReceivedTable={paymentReceivedTable}
				setTableError={setTableError}
				calculateTotalPayment={calculateTotalPayment}
				tableError={tableError}
			/>
			<div
				style={{ padding: '1rem 2rem 0' }}
				className="max-w-1297"
			>
				<div
					style={{
						padding: '10px 0px',
						float: 'right',
						margin: '10px 0px',
					}}
				>
					<div
						className="d-flex"
						style={{ justifyContent: 'flex-end' }}
					>
						<div style={{ color: '#000000', fontWeight: '600', textAlign: 'right' }}>
							<p>Amount Received</p>
							<p>Amount Used For Payment</p>
							<p
								style={{
									display: 'flex',
									textAlign: 'right',
									justifyContent: 'flex-end',
									aliginItems: 'center',
									gap: '5px',
								}}
							>
								<svg
									width="18"
									height="18"
									viewBox="0 0 18 18"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7258 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.7661 13.7258 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74228 2.17188 8.48882 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
										stroke="#BF9A18"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M9 6.75V9.75"
										stroke="#BF9A18"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M9 12.75H9.0075"
										stroke="#BF9A18"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								Amount Excess
							</p>
						</div>
						<div style={{ marginLeft: '35px', fontWeight: '600' }}>
							<p>₹ {Number(paymentReceived?.received_payment_amount ?? 0).toFixed(2)}/-</p>
							<p>₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}/-</p>
							<p>₹ {calculateTotalExcessPayment()?.toFixed(2) || 'N/A'}/-</p>
						</div>
					</div>
				</div>
				<div style={{ clear: 'both' }}></div>
			</div>
		</div>
	);
};
export default CreatePaymentReceived;
